import { connect } from 'react-redux';
import {
  loadDataMap,
  loadDataMapSamples,
  loadDataMapEntry,
  clearDataMapSearchResults,
} from 'js/actions';
import DataMapSamples from './DataMapSamples';

const mapStateToProps = (state, ownProps) => {
  const {
    dataMaps: { samples, searchResults, schemas },
    request,
  } = state;
  const {
    data: { id },
  } = ownProps;
  const isLoading = !!request.GET_DATA_MAP_SAMPLES_REQUEST || !!request.GET_DATA_MAP_ENTRY_REQUEST;
  const dataMapSamples = samples.id === id ? samples.flat : [];
  const dataMapSearchResults = searchResults.id === id ? searchResults.flat : null;
  const properties = schemas[id] ? schemas[id].properties : {};

  return {
    dataMapSamples,
    dataMapSearchResults,
    properties,
    isLoading,
  };
};

export default connect(mapStateToProps, {
  loadDataMap,
  loadDataMapSamples,
  loadDataMapEntry,
  clearDataMapSearchResults,
})(DataMapSamples);
